import axios from "../../http/axios";
import * as actionTypes from "./actionTypes";
export const GET_USERS = "GET_USERS";
export const GET_USER = "GET_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DOWNLOAD_USERS = "DOWNLOAD_USERS";
export const GET_SEARCH_USERS = "GET_SEARCH_USERS";

export function getUsers(token, page) {
  const request = axios.get(`/users/?page=${page}`, {
    headers: { Authorization: "JWT " + token }
  });
  return dispatch =>
    request
      .then(res =>
        dispatch({
          type: GET_USERS,
          payload: res.data
        })
      )
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
}
export function getUser(token, id) {
  const request = axios.get(`/users/${id}`, {
    headers: { Authorization: "JWT " + token }
  });
  return dispatch =>
    request
      .then(res =>
        dispatch({
          type: GET_USER,
          payload: res.data
        })
      )
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
}
export function getSearchUsers(token, value) {
  const request = axios.get(`/users/?search=${value}`, {
    headers: { Authorization: "JWT " + token }
  });
  return dispatch =>
    request
      .then(res =>
        dispatch({
          type: GET_SEARCH_USERS,
          payload: res.data
        })
      )
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
}
export function updateUser(id, data, token) {
  const request = axios.patch(`/users/${id}/`, data, {
    headers: { Authorization: "JWT " + token }
  });
  return dispatch =>
    request
      .then(res =>
        dispatch({
          type: UPDATE_USER,
          payload: res.data
        })
      )
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
}
export function downloadUsers(token, value) {
  const request = axios.get(
    `/users/?${value ? `&search=${value}` : ""}&show_all=true`,
    {
      headers: { Authorization: "JWT " + token, Accept: "text/csv" }
    }
  );
  return dispatch => {
    return request
      .then(res =>
        dispatch({
          type: DOWNLOAD_USERS,
          payload: res.data
        })
      )
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/user.js